export default {
  title: {
    CourseDetail: 'Course Details'
  },
  headers: {
    no: 'Course ID',
    name: 'Course Name',
    category: 'Category',
    type: 'Type',
    status: 'Status',
    sale: 'Sale'
  },
  label: {
    nameTh: 'Course Name (TH)',
    nameEn: 'Course Name (EN)',
    myCourse: 'My Courses',
    noCourseData: 'No course data found',
    getTreatment: 'Receive Treatment',
    getTreatmentServices: 'Receive Treatment/Service',
    setEndDate: 'Set Course Expiry Date',
    showCourseListSlip: 'Show Course List on Invoice',
    productDrugServiceList: 'Product, Prescription, and Service List',
    editCourse: 'Edit Course Information',
    type: 'Course Type',
    availableQuantity: 'Available Quantity'
  },
  placeholder: {
    searchName: 'Search course name',
    searchIdName: 'Search by course ID or name',
    enterId: 'Enter course ID',
    nameTh: 'Enter course name (TH)',
    nameEn: 'Enter course name (EN)',
    category: 'Enter category',
    enterInfo: 'Enter course information',
    selectProductServiceRelevant: 'Select relevant product/service',
    durationOfUsingTheCourse: 'Course duration',
    type: 'Search course type name',
    enterTypeInfo: 'Enter course type information'
  },
  toolTip: {
    create: 'Create Course',
    see: 'View Course',
    detail: 'Course Details',
    edit: 'Edit Course',
    delete: 'Delete Course',
    useCourse: 'Use Course'
  },
  modal: {
    create: {
      title: 'Create Course',
      success: 'Course created successfully!'
    },
    edit: {
      title: 'Edit Course',
      description: 'Please edit the desired course information',
      success: 'Course information updated successfully',
      type: {
        title: 'Edit Course Type Information',
        description1: 'You are editing the course type',
        success: 'Course type updated successfully!'
      }
    },
    delete: {
      title: 'Confirm Course Deletion',
      description1: 'You are deleting the course',
      description2: 'Do you want to proceed?',
      type: {
        title: 'Confirm Course Type Deletion',
        description1: 'You are deleting the course type',
        success: 'Course type deleted successfully!'
      }
    }
  }
}
